import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IProjectTargetResult } from './IProjectTargetResult'

export class ProjectTargetResult extends Entity<IProjectTargetResult> {
  id: number
  name: string
  organisationId: number

  public static new(payload: IProjectTargetResult): ProjectTargetResult {
    return plainToInstance(ProjectTargetResult, payload)
  }
}
